import { IpfModule } from "..";
import { container } from "../ioc/container.config";
import { TYPES } from "../ioc/types";
import { getGlobal, setGlobal } from "./global";

let ipfModule: IpfModule;

/**
 * Gets the IPF module from the DI container. 
 */
function getIpfModule() {

	if (!ipfModule) {

		ipfModule = container.get<IpfModule>(TYPES.IpfModule);
	}

	return ipfModule;
}
/**
 * Adds a message to the client log. Useful for debugging.
 * @param message The message to log.
 */
function addMessageToLog(message: string) {

	let messages = getGlobal<Array<string>>("clientLog");

	if (!messages) {

		messages = new Array<string>();
		setGlobal("clientLog", messages);
	}

	messages.push(message);
}

/**
 * Logs a message to the console and the message log.
 * @param message The message to log.
 * @param prefix Optional message prefix.
 */
export function logInfo(message: string, prefix?: string) {

	const ipf = getIpfModule();

	if (ipf.context.clientDebugEnabled) {

		if (prefix) {

			message = prefix + " - " + message;
		}

		console.log(message);
		addMessageToLog(message);
	}
}

/**
 * Logs an object to the console and the message log.
 * @param obj The object to log.
 */
export function logObject(obj: object) {

	const ipf = getIpfModule();

	if (ipf.context.clientDebugEnabled) {

		console.log(obj);
		addMessageToLog(JSON.stringify(obj));
	}
}

/**
 * Logs an error to the console and the message log.
 * @param message The message to log.
 * @param prefix Optional message prefix.
 */
export function logError(message: string, prefix?: string) {

	const ipf = getIpfModule();

	if (ipf.context.clientDebugEnabled) {

		if (prefix) {

			message = prefix + " - " + message;
		}

		console.error(message);
		addMessageToLog(message);
	}
}

